import React from "react";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.astroadiuser.app&pcampaignid=web_share";

function DownloadAppSection() {
  return (
    <section
      id="download-app"
      className="app-download-section xl:bg-[url('../../images/download-shape.png')] xl:bg-repeat-x xl:bg-top-left bg-[var(--primary-50)] py-10 md:py-16 relative overflow-hidden"
    >
      <div className="container">
        <div className="app-download-inner flex gap-[15px] flex-wrap items-center justify-between mt-[0px] xl:mt-[150px]">
          <div className="text-left max-w-[710px]">
            <span className="inline-flex items-center gap-2 tracking-[.2em] body-lg">
              <span className="w-[33px] h-[1px] bg-primary-500 inline-block"></span>
              DOWNLOAD APP
            </span>
            <h2 className="web-h2 text-zinc-900 mt-3">
              Your AstroAdi journey begins here.
            </h2>
            <p className="web-body-sm !leading-[1.5] text-zinc-600 mt-2">
              Explore astrology, connect with practitioners, discover spiritual
              services and access experiences designed around your interests.
            </p>
            <p className="web-body-sm !leading-[1.5] text-zinc-600 mt-2">
              Bring your personal exploration of astrology and wellness into one
              convenient application.
            </p>
            <div className="app-download-btn flex items-center gap-[12px] md:gap-[18px] flex-wrap mt-[18px] md:mt-[28px]">
              <span
                className="inline-block rounded-[10px] shadow-md"
                title="Coming soon on the App Store"
              >
                <img
                  src="/images/app-store.png"
                  alt="Download on the App Store"
                  className="!w-[168px] md:!w-[200px] h-auto"
                />
              </span>
              {/* When iOS is live, replace the span above with this link:
              <a
                href="https://apps.apple.com/app/id..."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-[10px] shadow-md transition-transform hover:scale-105"
              >
                <img
                  src="/images/app-store.png"
                  alt="Download on the App Store"
                  className="!w-[168px] md:!w-[200px] h-auto"
                />
              </a>
              */}
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-[10px] shadow-md transition-transform hover:scale-105"
              >
                <img
                  src="/images/google-play.png"
                  alt="Get it on Google Play"
                  className="!w-[168px] md:!w-[200px] h-auto"
                />
              </a>
            </div>
          </div>
          <div className="app-image-box hidden xl:block">
            <img src="/images/app-image.png" alt="app-image" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default DownloadAppSection;
